/** @format */

import { useIntl } from 'gatsby-plugin-intl';
import type { TTranslation } from './createProvider';

export const useAppTranslation = () => {
  const intl = useIntl();

  const formatMessage = (id: TTranslation, value?: any) => {
    try {
      return intl.formatMessage({ id }, value);
    } catch (error) {
      console.error(`Error formatting message with id: ${id}`, error);
      return `Missing translation: ${id}`;
    }
  };
  return { intl, t: formatMessage };
};

export { TTranslation };
